import type { Nullable } from "@core/domain/types/nullable.type";
import { BaseViewModel } from "@iot-platform/core";
import { injectable } from "inversify";
import { action, makeObservable, observable } from "mobx";
@injectable()
export class StationDetailHeaderComponentViewmodel extends BaseViewModel {
    @observable
    stationId: Nullable<number> = null;

    constructor() {
        super();
        makeObservable(this);
    }

    @action
    setStationId(stationId: string): void {
        this.stationId = Number(stationId);
    }
}
